import React, { useState } from 'react';
import { ContentTemplate, HeaderTemplate, KeyValue, Stepper, TitleHeader } from 'web-library';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SelectCandidate from './SelectCandidate';
import { useGetExamTypes } from '../../../api-refactored/candidate/useGetExamTypes';

interface SelectCandidatePageProps {
  routeSteps: { label: string }[];
}

const CoordinatorSelectCandidate = ({ routeSteps }: SelectCandidatePageProps) => {
  const { t } = useTranslation();

  const { examTypeCode } = useParams<{ examTypeCode: string }>();
  const [examTypeDescription, setExamTypeDescription] = useState<string>('-');

  useGetExamTypes({
    onSuccess: (res) => {
      res.forEach((item) => {
        if (item.code === examTypeCode) {
          setExamTypeDescription(item.description);
        }
      });
    },
  });

  return (
    <>
      <TitleHeader title={t('amendment->>GroupSubjectAmendment.NewSubjectAmendment')} />
      <HeaderTemplate>
        <KeyValue
          keyText={t('exam->>RegisterExamInstructions.Exam Level')}
          valueText={examTypeDescription}
        />
        <Stepper activeStep={0} steps={routeSteps} />
      </HeaderTemplate>
      <ContentTemplate type="full">
        <SelectCandidate />
      </ContentTemplate>
    </>
  );
};

export default CoordinatorSelectCandidate;
